import React, { Component } from 'react';
import { FiMoreVertical } from 'react-icons/fi';
import classNames from 'classnames';
import { themeGet } from 'styled-system';
import styled from 'styled-components';
import { TbCopy, TbEdit } from 'react-icons/tb';
import { Box, Button, Menu, MenuDivider, MenuItem, Popover } from 'core/components';
import { RemoveMenuItem } from 'core/form';

const Wrapper = styled(Box)`
  display: flex;
  gap: 4px;
  align-items: center;

  /* if showTitle is false, add a hover that shows a minimal Title area with controls */
  &.floating {
    backdrop-filter: blur(40px);
    background: ${themeGet('colors.decks.headerHover')};
    border: ${themeGet('borders.thin')};
    border-width: 0 0 1px 1px;
    position: absolute;
    top: 0;
    right: 0;
  }
`;

const buttonStyles = {
  padding: 0,
  width: 42,
  height: 38,
  borderTopLeftRadius: 0,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0
};

class WidgetMenu extends Component {
  render() {
    const { onRemove, onDuplicate, menuOptions, otherActions, canCustomize, configAction, floating, dragHeaderCls } =
      this.props;

    const menuButton = (
      <Button
        icon={FiMoreVertical}
        minimal
        onMouseDown={(e) => e.stopPropagation()}
        style={buttonStyles}
        ariaIsMenuButton
      />
    );

    return (
      <Wrapper className={classNames('config-menu', { floating })}>
        {floating && <Button className={dragHeaderCls} icon="move" minimal style={buttonStyles} />}
        <Popover
          position="bottom-right"
          modifiers={{
            flip: { enabled: true },
            keepTogether: { enabled: true },
            preventOverflow: { enabled: true, boundariesElement: 'window' },
            offset: { enabled: true, offset: '0,2px' }
          }}
          content={
            <Menu>
              {menuOptions}
              {canCustomize && (
                <>
                  {!!menuOptions && <MenuDivider css={{ '&:first-child': { display: 'none' } }} />}
                  {otherActions}
                  {onDuplicate && <MenuItem icon={TbCopy} text="Duplicate" onClick={onDuplicate} />}
                  {configAction && <MenuItem icon={TbEdit} text="Edit" onClick={configAction} />}
                  {onRemove && <RemoveMenuItem entityName="panel" onRemove={onRemove} />}
                </>
              )}
            </Menu>
          }
        >
          {menuButton}
        </Popover>
      </Wrapper>
    );
  }
}

export default WidgetMenu;
